export const getDocumentStyles = () => {
  const styleSheets = Array.from(document.styleSheets).filter(
    (styleSheet) => !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
  );
  let styles = '';
  for (let stylesheet of styleSheets) {
    for (let rule of stylesheet.cssRules) {
      styles += rule.cssText;
    }
  }

  return styles;
};
